
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booster/[boosterId]",
      function () {
        return require("private-next-pages/booster/[boosterId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booster/[boosterId]"])
      });
    }
  